/**
 * Gets the Attestio record ID from the hidden field Attestio injects into the form
 * @returns {string} - The record ID, or empty if Attestio hasn't loaded
 */
export function getAttestioCert() {
  return (
    /** @type {HTMLInputElement | null} */ (
      document.querySelector('input[name="attestio_record_id"]')
    )?.value || ''
  )
}
